import { render } from "./AuthPageView.vue?vue&type=template&id=cf041f42&ts=true"
import script from "./AuthPageView.vue?vue&type=script&lang=ts"
export * from "./AuthPageView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__